import {
  COMMIT_QUESTION_BLOCK,
  SUBMIT_ANSWER,
  GET_DEFAULT_RECOMMENDATIONS,
  GET_FILTERED_RECOMMENDATIONS,
} from 'actionTypes';

const ACTION_SETS = {
  blockState: [COMMIT_QUESTION_BLOCK, SUBMIT_ANSWER],
};

export function isActionInProgress(state, actionType) {
  const loadingState = state.isFetching[actionType];
  return !!loadingState && loadingState.isFetching;
}

// This will return true if any members of the given "action set" are in
// progress. The action sets are defined above.
export function actionsInProgress(state, actionSetName) {
  const relevantActionTypes = ACTION_SETS[actionSetName];
  if (!relevantActionTypes) {
    throw new Error(`There is no action set for ${actionSetName}`);
  }

  const loadingAction = relevantActionTypes.find(actionType =>
    isActionInProgress(state, actionType)
  );
  return !!loadingAction;
}

export function fetchingRecommendations(state) {
  return (
    isActionInProgress(state, GET_DEFAULT_RECOMMENDATIONS) ||
    isActionInProgress(state, GET_FILTERED_RECOMMENDATIONS)
  );
}



// WEBPACK FOOTER //
// ./src/selectors/loadingSelectors.js